<template>
  <div class="kye-report-echarts-bar_txt005">

    <slot name="thead">
      <div class="kye-report-echarts-bar_txt005_thead">
        <div class="kye-report-echarts-bar_txt005_name">
          <slot name="headName"></slot>
        </div>
        <div class="kye-report-echarts-bar_txt005_head" :class="{['kye-report-echarts-bar_txt005_head_center_flex']: leftUnit || rightUnit}">
          <div class="kye-report-echarts-bar_txt005_head_left" v-if="leftUnit" @click="summaryClick('summaryClick', 'left', datas.summary[1])">{{ datas.summary[0] && datas.summary[0].unit }}</div>
          <div class="kye-report-echarts-bar_txt005_head_center">
            <div class="legend-item"
              v-for="(item, index) in datas.summary" :key="index"
              @click="legendClick('legendClick', item, index)"
              :class="{
                [`legend-item-${index}`]: true
              }">
              <div class="legend-item_color"
                @click.stop="legendClick('legendLabel', item, index)"
                :style="`background-color:${item.color}`"></div>
              <div class="legend-item_label">{{ item.name }}</div>
              <Sort
                v-if="item.sort"
                :type="item.sortType"
                @sort="sort($event, index, item)" />
            </div>
          </div>
          <div class="kye-report-echarts-bar_txt005_head_right"
            v-if="rightUnit"
            @click="summaryClick('summaryClick', 'right', datas.summary[1])">
            {{ datas.summary[1] && datas.summary[1].unit }}
          </div>
        </div>
      </div>
    </slot>

    <div class="kye-report-echarts-bar_txt005_container">
      <div class="kye-report-echarts-bar_txt005_container_item"
        v-for="(item, index) in datas.data" :key="index"
        @click="dispatchEvent('rowClick', item, index)"
        :class="{
          [`kye-report-echarts-bar_txt005_container_item-${index}`]: true,
          'kye-report-echarts-bar_txt005_container_select': index === select
        }">
        <div class="kye-report-echarts-bar_txt005_container_item-left"
          @click.stop="dispatchEvent('labelClick', item, index)">
            <slot name="itemName" :item="item" :index="index" :select="select">
              <span :class="[item.left.valueClassName]">{{ item.left._name }}</span>
            </slot>
        </div>
        <div class="kye-report-echarts-bar_txt005_container_item-right">
          <!-- 左边 -->
          <div class="kye-report-echarts-bar_txt005-progress-left" v-if="item.left">
            <div class="kye-report-echarts-bar_txt005-progress-left-label" :class="[item.left.labelClassName]" @click.stop="dispatchEvent('rowUnit', item.left, index)">{{ item.left._value }}</div>
            <div class="kye-report-echarts-bar_txt005-progress-left-container">
              <el-progress class="kye-report-echarts-bar_txt005-left-progress"
                :color="config.leftColor"
                :percentage="item.left._percentage"
                :showText="false">
              </el-progress>
            </div>
          </div>
          <!-- 右边 -->
          <div class="kye-report-echarts-bar_txt005-progress-right" v-if="item.right">
            <div class="kye-report-echarts-bar_txt005-progress-right-label" :class="[item.right.labelClassName]" @click.stop="dispatchEvent('rowUnit', item.right, index)">{{ item.right._value }}</div>
            <div class="kye-report-echarts-bar_txt005-progress-right-container">
              <el-progress class="kye-report-echarts-bar_txt005-right-progress"
                :color="config.rightColor"
                :percentage="item.right._percentage"
                :showText="false">
              </el-progress>
            </div>
          </div>
        </div>
      </div>
      <slot name="after-content"></slot>
    </div>
  </div>
</template>

<script>
import Sort from '../txt003/sort.vue'
import { merge, isEmpty } from 'lodash'
const defaultConfig = {
  leftColor: '#8E88FF',
  rightColor: '#68C1FD',
  unit: 'unit',
  title: 'title',
  data: 'data',
  percentage: 'percentage',
  value: 'value',
  name: 'name'
}
export default {
  components: {
    Sort
  },
  props: {
    config: {
      type: Object,
      default: () => {
        return defaultConfig
      }
    },
    data: {
      type: Array,
      default: () => ([])
    },
    value: Number,
    isSelect: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      select: ''
    }
  },
  watch: {
    value: {
      handler(v) {
        this.select = v
      },
      immediate: true
    }
  },
  computed: {
    datas() {
      const config = merge(defaultConfig, this.config)
      const unitkey = config.unit
      const titlekey = config.title
      const datakey = config.data
      const namekey = config.name
      const valuekey = config.value
      const percentagekey = config.percentage

      const leftColor = config.leftColor
      const rightColor = config.rightColor
      const [data1 = {}, data2 = {}] = this.data || []
      const leftData = data1[datakey] || []
      const rightData = data2[datakey] || []
      const maxLength = Math.max(leftData.length, rightData.length)
      const summary = []
      summary.push(data1)
      !isEmpty(data2) && summary.push(data2)

      const _foramtData = (data) => {
        return {
          _name: data[namekey],
          _value: data[valuekey],
          _percentage: data[percentagekey],
        }
      }
      return {
        summary: summary.map((i = {}, index) => {
          return {
            ...i,
            unit: i[unitkey],
            name: i[titlekey],
            color: index === 0 ? leftColor : rightColor
          }
        }),
        data: Array(maxLength).fill(0).map((_, index) => {
          const leftDataItem = leftData[index]
          const rightDataItem = rightData[index]
          return {
            left: leftDataItem ? {
              ...leftDataItem,
              ..._foramtData(leftDataItem)
            } : false,
            right: rightDataItem ? {
              ...rightDataItem,
              ..._foramtData(rightDataItem)
            } : false
          }
        })
      }
    },
    leftUnit() {
      return this.datas.summary[0] && this.datas.summary[0].unit
    },
    rightUnit() {
      return this.datas.summary[1] && this.datas.summary[1].unit
    },
  },
  methods: {
    sort(sortType, index, item) {
      this.$emit('sort', sortType, index, item)
    },
    legendClick(eventName, data, index) {
      this.$emit(eventName, data, index)
    },
    summaryClick(eventName, type, item) {
      this.$emit(eventName, type, item)
    },
    dispatchEvent(type, item, index) {
      this.$emit('input', index)
      this.$emit(type, item, index)
      this.select = index
    },
  }
}
</script>

<style lang="less" scoped>
  @width100: 100%;
  .kye-report-echarts-bar_txt005{
    width: @width100;
    height: @width100;
    position: relative;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    /deep/ &-left-progress{
      .el-progress-bar__inner{
        border-radius: 0;
        border-top-right-radius:2px;
        border-bottom-right-radius:2px;
      }
    }
    /deep/ &-right-progress{
      .el-progress-bar__inner{
        border-radius: 0;
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
      }
    }
    /deep/ .el-progress-bar__outer{
      background-color: #F2F3F7;
    }
    /deep/ .el-progress-bar__outer{
      border-radius: 0px;
      &__inner{
        border-radius: 1px;
      }
    }
    &_thead {
      display: flex;
      width: 100%;
      padding-right:24px;
    }
    &_name {
      width: 88px;
      height: 40px;
    }
    &_head{
      display: flex;
      justify-content: center;
      height: 40px;
      align-items: center;
      flex: 1;
      // padding-left: 88px;
      color: #666;
      &_left{
        min-width: 100px;
      }
      &_center{
        display: flex;
        align-items: center;
        gap: 26px;
        .legend-item{
          display: flex;
          align-items: center;
          cursor: pointer;
          &_color{
            width: 8px;
            height: 8px;
            border-radius: 100%;
            margin-right: 8px;
          }
          &_label{
            margin-right: 4px;
            color: #333333;
          }
        }
      }
      &_right{
        min-width: 100px;
        text-align: right;
      }
    }
    &_head_center_flex {
      justify-content: space-between;
    }
    &_container{
      flex: 1;
      overflow-y: auto;
      &::-webkit-scrollbar{
        width: 4px;
        height: 4px;
      }
      &::-webkit-scrollbar-thumb{
        border-radius: 2px;
        background-color: rgba(118, 83, 214, .4);
      }
      &_select{
        background: #E7ECFF;
        .kye-report-echarts-bar_txt005_container_item-left{
          color: #FF9300;
        }
        .kye-report-echarts-bar_txt005-progress-left-container{
          /deep/ .el-progress-bar__inner{
            background-color: #7874d3 !important;
          }
        }
        .kye-report-echarts-bar_txt005-progress-right-container{
          /deep/ .el-progress-bar__inner{
            background-color: #6ba2d2 !important;
          }
        }

      }
      &_item{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        height: 40px;
        padding: 6px 24px;
        cursor: pointer;
        &:hover{
          background: #F6F8FC;
        }
        &:hover &-left{
          >span {
            color: #fff;
            background-color: #FF9300;
            padding: 6px;
            border-radius: 4px;
            height: 22px;
            line-height: 10px;
          }
        }
        &-left{
          width: 48px;
          height: 100%;
          text-align: right;
          display: flex;
          align-items: flex-end;
          justify-content: end;
          position: relative;
          top: 2px;
          color: #666;
        }
        &-right{
          flex:1;
          display: flex;
          align-items: flex-end;
          gap: 4px;
          height: 100%;
          .kye-report-echarts-bar_txt005-progress-left, .kye-report-echarts-bar_txt005-progress-right{
            flex:1;
            height: 100%;
            display: flex;
            align-items: flex-end;
            flex-wrap: wrap;
            &-label{
              color: #333333;
              font-size: 12px;
              margin-bottom: 4px;
              width: 100%;
            }
            &-container{
              transform: rotate(180deg);
              height: 6px;
              width: 100%;
            }
          }

          .kye-report-echarts-bar_txt005-progress-right{
            &-label{
              text-align: right;
            }
            &-container{
              transform: rotate(0deg);
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/echarts/bar-x/txt004/index.vue